/*
 * @Author: Shirtiny
 * @Date: 2021-06-10 10:58:27
 * @LastEditTime: 2021-06-10 11:09:51
 * @Description:
 */
// https://react-hot-toast.com/docs
import toast from "react-hot-toast";

const error = (message = "") => toast.error(message);

const notifier = {
  error,
};
export default notifier;
